import {
  Chip,
  DownIcon,
  FilterIcon,
  GKButton,
  Grid2,
  Popover,
  Typography,
  UpIcon,
} from "components";
import {
  PortfolioGroupFilter,
  SliderFilter,
} from "Pages/EquityBasket/OrderSimulation/Filters";
import { useState } from "react";
import { useFormContext } from "react-hook-form";
import { numberToCurrency } from "utils";

type FilterType = "portfolio_group" | "portfolio_value";

const FilterPopover = () => {
  const [activeFilterType, setActiveFilterType] = useState<FilterType | null>(
    null,
  );
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const form = useFormContext();

  const handleClick = (
    event: React.MouseEvent<HTMLButtonElement>,
    filterType: FilterType,
  ) => {
    setAnchorEl(event.currentTarget);
    setActiveFilterType(filterType);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setActiveFilterType(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "mf-filter-popover" : undefined;

  const groupValue: any[] =
    form.getValues("portfolioSelectionFilter.portfolio_group") || [];
  const valueRange: number[] =
    form.getValues("portfolioSelectionFilter.portfolio_value") || [];

  return (
    <>
      <Grid2
        container
        spacing={1}
        sx={{ alignItems: "center", display: "flex", gap: 1 }}
      >
        <Typography
          fontSize={12}
          fontWeight={500}
          color="#4F4F4F"
          sx={{ alignItems: "center", display: "flex", gap: 1 }}
        >
          <FilterIcon />
          Filters:
        </Typography>
        <GKButton
          variant="outlined"
          color="dark"
          endIcon={
            activeFilterType === "portfolio_group" && open ? (
              <UpIcon width={16} height={16} />
            ) : (
              <DownIcon width={16} height={16} />
            )
          }
          onClick={(e) => handleClick(e, "portfolio_group")}
        >
          <Typography
            fontSize={12}
            fontWeight={500}
            color="#4F4F4F"
            sx={{ alignItems: "center", display: "flex", gap: 1 }}
          >
            Portfolio Group
            {groupValue.length !== 0 && <Chip label={groupValue.length} />}
          </Typography>
        </GKButton>
        <GKButton
          variant="outlined"
          color="dark"
          endIcon={
            activeFilterType === "portfolio_value" && open ? (
              <UpIcon width={16} height={16} />
            ) : (
              <DownIcon width={16} height={16} />
            )
          }
          onClick={(e) => handleClick(e, "portfolio_value")}
        >
          <Typography
            fontSize={12}
            fontWeight={500}
            color="#4F4F4F"
            sx={{ alignItems: "center", display: "flex", gap: 1 }}
          >
            Portfolio Value
            {valueRange.length === 2 && (
              <Typography fontSize={12} fontWeight={600}>
                {numberToCurrency(valueRange[0])} -{" "}
                {numberToCurrency(valueRange[1])}
              </Typography>
            )}
          </Typography>
        </GKButton>
      </Grid2>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        slotProps={{ paper: { sx: { width: "320px", borderRadius: "8px" } } }}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
      >
        {activeFilterType === "portfolio_group" && (
          <PortfolioGroupFilter setOpen={handleClose} />
        )}
        {activeFilterType === "portfolio_value" && (
          <SliderFilter
            setOpen={handleClose}
            formKey={"portfolioSelectionFilter.portfolio_value"}
            maxValue={100_00_00_000}
          />
        )}
      </Popover>
    </>
  );
};

export default FilterPopover;
